export const getStringLength = (str) => {
  return str ? str.length : 0;
};
